import { TreeSelect, TreeSelectProps } from 'antd'
import React from 'react'
import { FilterTreeSelectPc } from '../FilterTreeSelect/FilterTreeSelectPc';
import { useSearchConditionPc } from '../hooks/useSearchCondition';
export interface FilterGoodsCategoryPcProps extends TreeSelectProps {
    mode?: 'multiple' | 'tags';
}


const FilterGoodsCategory = (props: FilterGoodsCategoryPcProps) => {
    const { value, placeholder = '商品分类', mode = 'multiple', ...rest } = props;
    const { searchCondition, loading, getInitData } = useSearchConditionPc({ goods: ['category'] })
    return (
        <>
            <FilterTreeSelectPc
                allowClear
                value={value}
                multiple={mode != 'multiple' ? false : true}
                dropdownStyle={{ maxHeight: 400, overflow: "auto", minWidth: 400,whiteSpace: 'nowrap' }}
                treeCheckable={mode != 'multiple' ? false : true}
                loading={loading}
                getInitData={getInitData}
                style={{ width: '100%' }}
                // popupClassName='ant-select-tree-title'
                treeData={searchCondition.goods ? searchCondition.goods.category : []}
                placeholder={placeholder}
                // getPopupContainer={(triggerNode) => triggerNode.parentNode}
                treeDefaultExpandAll
                // dropdownRender={menu => (
                //     <div style={{ maxHeight: 400, background: '#000', overflow: 'auto' }}>
                //         <div className="custom-dropdown">
                //             {menu}
                //         </div>
                //     </div>
                // )}
                // treeNodeFilterProp={'title'}
                {...rest}
            /></>
    )
}

export default FilterGoodsCategory;